import { ImageMultipleIcon } from './ImageMultipleIcon';

/**
 * author: Google
 * id E7CA4672-9863-4015-B3C5-D2C8DEBD2F2F
 * name image-multiple
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-multiple.svg
 * tags
 */
export const CollectionsIcon = ImageMultipleIcon;
export default CollectionsIcon